// ============================================================================
// CrewAhead Maritime Platform - Store Barrel Export
// ============================================================================

// Auth Store
export {
  useAuthStore,
  selectUserRole,
  selectHasRole,
  selectIsEmployer,
  selectIsSeafarer,
  selectIsShoreStaff,
  selectIsAdmin,
  selectUserFullName,
  selectUserAvatar,
} from './authStore';
export type { AuthState } from './authStore';

// User Store
export {
  useUserStore,
  selectCurrentProfile,
  selectProfileCompleteness,
  selectNotificationsEnabled,
} from './userStore';
export type { UserState, UserPreferences, ToastMessage } from './userStore';

// UI Store
export {
  useUIStore,
  selectEffectiveTheme,
  selectIsModalOpen,
  selectIsDrawerOpen,
  selectDrawerContent,
  selectIsLoading,
} from './uiStore';
export type { UIState, Theme, ModalId, SidebarView, DrawerState } from './uiStore';
